/**
 * Parsing decimali in formato italiano (virgola o punto). Fix del bug visto
 * nella vecchia pagina normative: input type="number" scartava silenziosamente
 * valori con virgola ("12,5").
 *
 * @returns {number|null|NaN} null per stringa vuota, NaN per input non numerico.
 */
export function parseDecimalIT(input) {
  if (input == null) return null;
  const s = String(input).trim();
  if (s === "") return null;
  const n = Number(s.replace(",", "."));
  return Number.isFinite(n) ? n : NaN;
}
